import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconScheduleSvg } from "./IconScheduleSvg.mjs";
const IconSchedule = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconScheduleSvg, ...iconProps });
};
export {
  IconSchedule
};
